import CheckboxInput from "./CheckboxInput";
import styles from "Styles/Inputs.module.css";

export default function CheckboxGroup({
  IDRoot = "checkbox-input",
  checkboxData = [],
  handleCheck,
  useValue = false,
}) {
  return (
    <div className={styles.checkboxGroupWrapper}>
      {checkboxData.length > 0 &&
        checkboxData.map((checkbox, index) => (
          <CheckboxInput
            value={useValue && checkbox.value ? checkbox.value : checkbox.label}
            label={checkbox.label}
            key={index}
            index={index}
            IDRoot={IDRoot}
            handleCheck={handleCheck}
            checked={checkbox.checked}
            disabled={checkbox.disabled}
          />
        ))}
    </div>
  );
}
